import {FINALIZE_DETAILS} from './FinalizeType';

const initialState={
    UserName:10,
    Password:'',
    Role:'',
    Id:''
}

const finalizeReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case FINALIZE_DETAILS: return{
            ...state,
            UserName:state.UserName,
            Password:state.Password,
            Role:state.Role,
            Id:state.Id
        }
        default: return state
    }
}

export default finalizeReducer;